import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormatIbanDirective } from './directives/format-iban.directive';
import { DisableControlDirective } from './directives/disable-control.directive';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { LoadingComponent } from './components/loading/loading.component';
import { TooltipIconComponent } from './components/tooltip-icon/tooltip-icon.component';
import { OtpFormComponent } from './components/otp-form/otp-form.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgSelectModule } from '@ng-select/ng-select';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { InlineEditableComponent } from './components/inline-editable/inline-editable.component';
import { ParseCurrencyDirective } from './directives/parse-currency.directive';
import { FormatIbanPipe } from './pipes/format-iban.pipe';
import { FormatCCCPipe } from './pipes/format-ccc.pipe';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { GroupByPipe } from './pipes/group-by.pipe';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { ErrorComponent } from './components/error/error.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { SortByPipe } from './pipes/sort-by.pipe';
import { BannerBackgroundDirective } from './directives/banner-background.directive';
import { ModalCookiesComponent } from './components/modal-cookies/modal-cookies.component';
import { SelectDepositComponent } from '@shared/components/select-deposit/select-deposit.component';
import { removeFirstCharactersPipe } from './pipes/removeFisrtCharacters.pipe';
import { AutoSelectFirstItemDirective } from './directives/auto-select-first-item.directive';
import { NotificationModalComponent } from './components/notification-modal/notification-modal.component';
import { NotificationContentComponent } from './components/notification-content/notification-content.component';
import { ReplaceWordWithLinkDirective } from './directives/replace-word-with-link.directive';
import { AlphanumericOnlyDirective } from './directives/alphanumeric-only.directive';
import { DynamicLinkComponent } from './components/dynamic-link/dynamic-link.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InactivityModalComponent } from './components/inactivity-modal/inactivity-modal.component';

// define ngx bootstrap locale
defineLocale('es', esLocale);

const INNER_COMPONENTS = [];

const EXPORTABLE_COMPONENTS = [
  TooltipIconComponent,
  ErrorModalComponent,
  LoadingComponent,
  OtpFormComponent,
  InlineEditableComponent,
  ConfirmModalComponent,
  InfoModalComponent,
  InlineEditableComponent,
  ErrorComponent,
  ErrorMessageComponent,
  ModalCookiesComponent,
  SelectDepositComponent,
  NotificationModalComponent,
  NotificationContentComponent,
  DynamicLinkComponent,
  InactivityModalComponent,
];

const INNER_MODULES = [];

const MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  BsDatepickerModule,
  ModalModule,
  TabsModule,
  AccordionModule,
  NgSelectModule,
  CollapseModule,
  TooltipModule,
];

const DIRECTIVES = [
  FormatIbanDirective,
  DisableControlDirective,
  ParseCurrencyDirective,
  BannerBackgroundDirective,
  AutoSelectFirstItemDirective,
  ReplaceWordWithLinkDirective,
  AlphanumericOnlyDirective,
];

const PIPES = [FormatIbanPipe, FormatCCCPipe, GroupByPipe, SortByPipe, removeFirstCharactersPipe];

const PROVIDERS = [];

@NgModule({
  declarations: [...INNER_COMPONENTS, ...EXPORTABLE_COMPONENTS, ...DIRECTIVES, ...PIPES],
  imports: [...INNER_MODULES, ...MODULES],
  providers: [...PROVIDERS],
  exports: [...MODULES, ...EXPORTABLE_COMPONENTS, ...DIRECTIVES, ...PIPES],
})
export class SharedModule {}
